import {Box, Button} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useMutation} from "@apollo/client";
import {BlurredBackdropModal} from "../BlurredBackdropModal/BlurredBackdropModal";

import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {ACTION_TAKEN_ON_USER_NOTIFICATION} from "../../store/mutations/ActionTakenOnUserNotification";
import {Limit200EUR} from "./PopupTemplates/Limit200EUR";
import {
    ActionTakenOnUserNotificationMutation,
    ActionTakenOnUserNotificationMutationVariables,
    UserNotification
} from "../../gql/graphql";

export const PopupNotification : React.FC<{ notification: UserNotification }> = (props) => {
    const {t} = useTranslation();
    const [actionTaken, actionTakenState] = useMutation<ActionTakenOnUserNotificationMutation, ActionTakenOnUserNotificationMutationVariables>(ACTION_TAKEN_ON_USER_NOTIFICATION);
    const [showPopup, setShowPopup] = useState(true);
    
    const takeAction = () => {
        actionTaken({
            variables:
                {
                    value:  parseFloat(props.notification.id)
                },
            onCompleted() {
                
                setShowPopup(false);
            }
        });
    }

    return (
        <BlurredBackdropModal
            open={showPopup} handleClose={() => setShowPopup(false)}
            dialogSx={{width: 600}}
        >
            <>
                <Box sx={{
                    display: 'block',
                    width: '100%',
                    position: 'relative'
                }}>

                    <Button onClick={() => setShowPopup(false)}
                            sx={{position: 'absolute', top: 0, right: 0, pt: 2}}>
                        <CloseIcon
                            sx={{
                                color: (theme) => theme.palette.text.primary,
                                width: 24,
                                height: 24
                            }}/></Button>
                </Box>
                <Box sx={{
                    paddingLeft: 4, paddingRight: 4, paddingBottom: 2,
                    paddingTop: 4, overflowY: 'auto', display: 'flex', flexDirection: 'column'
                }}>
                    {props.notification.notificationUuid == "ef10535c-c521-4897-bdf0-3cf51e19eac0" && (<Limit200EUR actionTakenState={actionTakenState} takeAction={takeAction}/>)}
                </Box>
            </>
        </BlurredBackdropModal>
    )
}